import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import TextField from "@mui/material/TextField";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { ListItemButton } from "@mui/material";
//
import { Link as RLink } from "react-router-dom";
//
import { useSearchContactsQuery } from "../../api/contact";
import { Contact, ContactResponse } from "./contactSlice";
import { fromText } from "../filter/filterSlice";

export default function ContactList() {
    const [searchValue, setSearchValue] = useState<string>("");
    const onSearchValueChange = (t: string) => {
        //ticketV.title = t;
        setSearchValue(t);
    };
    const { data, isFetching, isError } = useSearchContactsQuery(
        fromText(searchValue),
        { skip: searchValue.trim().length < 2 },
    );
    return (
        <Box>
            <br />
            <br />
            <TextField
                id="contact-search-name"
                label="name"
                variant="standard"
                defaultValue={searchValue}
                placeholder="Placeholder"
                inputProps={{ style: { fontFamily: "courier new" } }}
                multiline
                fullWidth
                onChange={(e) => {
                    onSearchValueChange(e.target.value);
                }}
                sx={{ fontFamily: "courrier" }}
            />
            {isError && (
                <>
                    <br />
                    <br />
                    Error
                </>
            )}
            {isFetching && (
                <>
                    <br />
                    <br />
                    Fetching
                </>
            )}
            {data && <ContactListDisplay data={data} />}
        </Box>
    );
}

type ContactListProps = {
    data: ContactResponse;
};
function ContactListDisplay({ data }: ContactListProps) {
    return (
        <List
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
        >
            {Object.values(data.contacts).map((c) => (
                <ListItem alignItems="flex-start">
                    <ListItemButton
                        component={RLink}
                        to={"/contact/view/" + c.metadata.id}
                    >
                        <ListItemAvatar>
                            <Avatar
                                alt="Remy Sharp"
                                src="/static/images/avatar/1.jpg"
                            />
                        </ListItemAvatar>
                        <ListItemText
                            primary={c.first_name}
                            secondary={
                                <React.Fragment>
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        sx={{
                                            color: "text.primary",
                                            display: "inline",
                                        }}
                                    >
                                        {c.last_name}
                                    </Typography>
                                    " — " {c.content.content}
                                    {c.birthday}
                                </React.Fragment>
                            }
                        />
                    </ListItemButton>
                </ListItem>
            ))}
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Avatar
                        alt="Remy Sharp"
                        src="/static/images/avatar/1.jpg"
                    />
                </ListItemAvatar>
                <ListItemText
                    primary="Brunch this weekend?"
                    secondary={
                        <React.Fragment>
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{
                                    color: "text.primary",
                                    display: "inline",
                                }}
                            >
                                Ali Connors
                            </Typography>
                            {
                                " — I'll be in your neighborhood doing errands this…"
                            }
                        </React.Fragment>
                    }
                />
            </ListItem>
            <Divider variant="inset" component="li" />
            <ListItem alignItems="flex-start">
                <ListItemButton>
                    <ListItemAvatar>
                        <Avatar
                            alt="Travis Howard"
                            src="/static/images/avatar/2.jpg"
                        />
                    </ListItemAvatar>
                    <ListItemText
                        primary="Summer BBQ"
                        secondary={
                            <React.Fragment>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{
                                        color: "text.primary",
                                        display: "inline",
                                    }}
                                >
                                    to Scott, Alex, Jennifer
                                </Typography>
                                {
                                    " — Wish I could come, but I'm out of town this…"
                                }
                            </React.Fragment>
                        }
                    />
                </ListItemButton>
            </ListItem>
            <Divider variant="inset" component="li" />
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Avatar
                        alt="Cindy Baker"
                        src="/static/images/avatar/3.jpg"
                    />
                </ListItemAvatar>
                <ListItemText
                    primary="Oui Oui"
                    secondary={
                        <React.Fragment>
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{
                                    color: "text.primary",
                                    display: "inline",
                                }}
                            >
                                Sandra Adams
                            </Typography>
                            {
                                " — Do you have Paris recommendations? Have you ever…"
                            }
                        </React.Fragment>
                    }
                />
            </ListItem>
        </List>
    );
}
